// extracted by css-extract-rspack-plugin
export default {"text":"TextFormatting-module__text___qlUbg"};